import { gql } from '@apollo/client';

export const SEND_REGULAR_HEALTH_CHECKUP_REPORT_TO_EGOV = gql`
  mutation SendRegularHealthCheckupReportToEgov($input: SendRegularHealthCheckupReportToEgovInput!) {
    sendRegularHealthCheckupReportToEgov(input: $input) {
      regularHealthCheckupReport {
        id
      }
    }
  }
`;

export interface SendRegularHealthCheckupReportToEgovQueryVariables {
  input: {
    id: string;
    attachments?: File[];
  };
}

export interface SendRegularHealthCheckupReportToEgovQueryResult {
  sendRegularHealthCheckupReportToEgov: {
    regularHealthCheckupReport: {
      id: string;
    };
  };
}

export interface EgovValidationErrors {
  precheck?: string[];
  form?: EgovFormValidationError[];
}

export interface EgovFormValidationError {
  name: string;
  num: number;
  errorMessage: string;
  input?: string;
  ranges?: { begin: number; end: number }[];
}
